/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InternalGetAliasesAndPreferencesRequest} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/internal_get_aliases_and_preferences.pb'
import {InternalGetAliasesAndPreferencesResponse} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/internal_get_aliases_and_preferences.pb'


export const internalGetAliasesAndPreferences = (request:InternalGetAliasesAndPreferencesRequest, options?: CashRequestOptions) => post<InternalGetAliasesAndPreferencesRequest, InternalGetAliasesAndPreferencesResponse>("/2.0/cash/internal-get-aliases-and-preferences", request, {...options, rejectOnError: true })